/* eslint-disable import/no-named-as-default-member */
import i18nInstance from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18nInstance
  .use(initReactI18next)
  .use(Backend)
  .init({
    lng: localStorage.getItem('preferred_language') || 'en',
    fallbackLng: localStorage.getItem('preferred_language') || 'en',
    ns: [
      'common',
      'pages.contacts',
      'pages.home',
      'pages.login',
      'pages.profile',
      'pages.more',
      'pages.familyMembers',
      'pages.idCards',
      'pages.benefits',
      'pages.termsofuse',
      'pages.benefitDocuments',
      'pages.inbox',
      'pages.notFound',
      'pages.settings',
      'pages.changePassword',
      'pages.forgotPassword',
      'navigation.main',
      'navigation.additional',
      'messages.login',
      'messages.idCards',
      'messages.contacts',
      'messages.dialog',
      'messages.forgotPassword',
      'messages.changePassword',
      'messages.notEligible',
      'messages.survey',
      'pages.volume',
      'pages.openEnrollment',
      'pages.enrollment.review',
      'pages.enrollmentAddProviders',
      'enrollment.batchDeclineBenefitsModal',
      'enrollment.cartDrawer',
      'enrollment.beforeGetStarted',
    ],
  });
export const i18n = i18nInstance;
